<div class="customer-number" [class.customer-number--with-icon]="withIcon">
  @if (withIcon) {
  <hls-icon
    class="customer-number__icon"
    icon="action-copy"
  ></hls-icon>
  }
  <div class="customer-number__text">
    <span
      class="customer-number__label"
      [translate]="'carrier.customer-number.label'"
    ></span>
    <button
      type="button"
      class="customer-number__value"
      #tooltip="matTooltip"
      [matTooltip]="
        (copied
          ? 'carrier.customer-number.copied'
          : 'carrier.customer-number.copy-hint'
        ) | translate
      "
      matTooltipPosition="below"
      (click)="copy(); tooltip.show()"
    >
      {{ customerNumber$ | async }}
    </button>
  </div>
  <span class="customer-number__sr-only" role="status" aria-live="polite">
    @if (copied) {
    <span [translate]="'carrier.customer-number.copied'"></span>
    }
  </span>
</div>
